import { API_URL } from "./api";

// Ключ в localStorage, куда кладём токен обхода (совпадает с cookie на сервере).
export const BYPASS_KEY = "mb_bypass";

// При заходе по ссылке ?devtoken=<секрет> — запомнить токен и убрать его из URL.
export function captureBypassFromUrl() {
    try {
        const p = new URLSearchParams(window.location.search);
        const t = p.get("devtoken") || p.get("bypass");
        if (t) {
            localStorage.setItem(BYPASS_KEY, t);
            // продублируем в cookie — чтобы nginx/документ-баннер тоже пропускал разработчика
            document.cookie = `${BYPASS_KEY}=${t}; path=/; max-age=604800; SameSite=Lax`;
            p.delete("devtoken"); p.delete("bypass");
            const qs = p.toString();
            window.history.replaceState({}, "",
                window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
        }
    } catch (e) { /* no-op */ }
}

export function getBypassToken() {
    try { return localStorage.getItem(BYPASS_KEY) || ""; } catch (e) { return ""; }
}

// Спрашиваем сервер: включён ли режим и пущен ли ЭТОТ клиент (по токену).
// При ошибке считаем, что сайт работает (действия всё равно застопорит 503-гейт API).
export async function checkMaintenance() {
    try {
        const tok = getBypassToken();
        const res = await fetch(API_URL + "/maintenance/", {
            headers: tok ? { "X-Maintenance-Bypass": tok } : {},
            credentials: "include",
            cache: "no-store",
        });
        if (!res.ok) return { maintenance: false, allowed: true };
        return await res.json();   // { maintenance, allowed }
    } catch (e) {
        return { maintenance: false, allowed: true };
    }
}